import { AppState } from 'src/store';
import * as types from './types';
import _ from 'lodash';

export const SelectState = () => (state: AppState) => {
    return state.explorer;
}

export const SelectEntities = () => (state: AppState) => {
    return state.explorer.entities;
}

export const SelectEntity = (locator: types.Locator) => (state: AppState) => {
    const { name, id } = locator;
    return _.get(state.explorer.entities, [name, id], undefined);
}

export const SelectStack = () => (state: AppState) => {
    return state.explorer.stack;
}
